import { APIClient } from "./ApiService";

import * as url from "./UrlHelper";

const api = new APIClient();

export const postUserLogin = (data: any) =>
  api.create(url.POST_USER_LOGIN, data);
